<template>

    <div class="box box-solid">
        <div class="box-header">
            <h2 class="box-title">Graph</h2>
            <div class="box-tools">
                <div class="btn-group btn-group-xs">
                    <button class="btn btn-default" type="button" @click="prevYear()"><i class="fa fa-chevron-left"></i></button>
                    <button class="btn btn-default" type="button">{{ currentyear }}</button>
                    <button class="btn btn-default" type="button" @click="nextYear()"><i class="fa fa-chevron-right"></i></button>
                </div>
            </div>
        </div>
        <div class="box-body no-padding" style="min-height:300px;">
            <line-chart
                v-if="!loading"
                :height="500"
                :chartdata="chartdata"
                :options="chartoptions"
            ></line-chart>
        </div>
        <div class="overlay" v-show="loading">
            <i class="fa fa-refresh fa-spin"></i>
        </div>
    </div>

</template>

<script>

    import axios from "axios";
    import moment from 'moment';
    import LineChart from "../Charts/Line";
    import toCurrency from "../../filters/toCurrency";

    export default {

        components: {

            LineChart,

        },

        data() {
            return{
                chartdata:{},
                currentyear:2019,
                chartoptions:{},
                loading:true,
            }
        },

        methods: {

            getGraphData() {
                axios.get(this.graphEndpoint,{params:{year:this.currentyear}})
                .then(resp => {
                    this.chartdata = resp.data.data.chartdata;
                    this.chartoptions = resp.data.data.chartoptions;
                    this.loading = false;
                });
            },

            nextYear(){
                this.loading = true;
                this.currentyear = parseInt(this.currentyear) + 1;
                this.getGraphData();
            },

            prevYear() {
                this.loading = true;
                this.currentyear = parseInt(this.currentyear) - 1;
                this.getGraphData();
            },

        },

        mounted() {

            this.currentyear = moment().format("YYYY");
            this.getGraphData();

        },

        name:"BusinessGraph",

        props: {

            graphEndpoint: {
                required:true,
            },

        }

    }

</script>
